var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "app", attrs: { id: "app" } },
    [
      _c("router-view"),
      _c("mfa-verify-dialog", {
        ref: "mfaDialog",
        attrs: { visible: _vm.showMfaDialog },
        on: {
          "update:visible": function ($event) {
            _vm.showMfaDialog = $event
          },
          confirm: _vm.handleMfaConfirm,
          close: _vm.handleMfaClose,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }